import React from 'react';

export const pageMeta = {
  "name": "JS HTML DOM",
  "link": "/javascript/examples/html-dom"
};

export default function JavascriptExamplesHtmlDom() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">JS HTML DOM</h2>
      <p>Route: /javascript/examples/html-dom</p>
      <h3 className="mt-4 font-medium">sub_content</h3>
      <pre>{JSON.stringify(pageMeta, null, 2)}</pre>
    </div>
  );
}
